import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate,Outlet, useLocation } from 'react-router-dom';
import {useCampaigns} from '../../context/CampaignContext'
import {statusColors} from '../../Helpers/Colors'
import axios from 'axios';
import {toast} from 'react-toastify';
import {formatDate} from '../../Helpers/FormatDate'
import { useAuth } from '../../context/AuthContext';
// Sample data – replace with real data from your API




const CampaignDashboard = () => {
  const [campaigns,setCampaigns] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
const navigate = useNavigate();
const location = useLocation();
const isFormPage =
    location.pathname.endsWith('/new') ||
    location.pathname.includes('/edit');

const {campaignsList,isLoading,refetchCampaigns } = useCampaigns()

  const { user,heroku } = useAuth();


const [actionLoadingId, setActionLoadingId] = useState(null);


const handleCampaignAction = async (campaign) => {
  const isActive = campaign.status === 'Active';
  const action = isActive ? 'cancel' : 'delete';

  if (!window.confirm(`Are you sure you want to ${action} "${campaign.campaignTitle}"?`)) {
    return;
  }

  try {
    console.log( campaign.campaignID)
    setActionLoadingId(campaign.campaignID);
  let r = {campaignID: campaign.campaignID}
  console.log(r)
   await axios.delete(`${heroku}/usps/delete-campaign`, {
  data: { campaignID: campaign.campaignID },
});
await refetchCampaigns({ silent: true });
    toast.success(
      isActive ? 'Campaign cancelled successfully' : 'Campaign deleted successfully'
    );

    // Refresh the list, then go back to the dashboard
    // refetchCampaigns?.();   // if your CampaignContext exposes one
    navigate('/informed');
  } catch (error) {
    console.error(
      `USPS ${action} failed:`,
      JSON.stringify(error.response?.data || error.message, null, 2)
    );
    toast.error(
      error.response?.data?.details?.error?.errors?.[0]?.message ||
        `Failed to ${action} campaign`
    );
  } finally {
    setActionLoadingId(null);
  }
};

useEffect(() => {
 
  // Try several possible shapes
  const rawList =
    campaignsList?.usps?.campaigns ||
    campaignsList?.campaigns ||
    (Array.isArray(campaignsList) ? campaignsList : null);

  if (!rawList || !Array.isArray(rawList)) {
    console.log('No campaigns array found – setting empty');
    setCampaigns([]);
    return;
  }

  console.log('Found', rawList.length, 'campaigns. First one:', rawList[0]);

  const mapped = rawList.map((c) => ({
    id: c.campaignID || c.id,
    campaignTitle: c.campaignTitle || c.title || c.name || 'Untitled',
    campaignCode: c.campaignCode || c.code || c.campaignID,
    brandDisplayName: c.brandDisplayName || c.brand || c.submitterName || '—',
    startDate: c.startDate || c.start || null,
    endDate: c.endDate || c.end || null,
    mailpieceShape: c.mailpieceShape,
    status: c.status || c.campaignStatus || 'Draft',
    ...c,
  }));

  setCampaigns(mapped);
}, [campaignsList]);


const statusCounts = useMemo(() => {
  const counts = {
    total: campaigns.length,
  };

  campaigns.forEach((campaign) => {
    const status = (campaign.status || 'UNKNOWN').toUpperCase();

    counts[status] = (counts[status] || 0) + 1;
  });

  return counts;
}, [campaigns]);

console.log(campaigns)
// Unique statuses that actually exist in the data
const availableStatuses = [...new Set(campaigns.map((c) => c.status).filter(Boolean))];

// Filter (keep your existing one, it’s fine)
const filteredCampaigns = (campaigns || []).filter((c) => {
  const title = (c.campaignTitle || '').toLowerCase();
  const code  = (c.campaignCode  || '').toLowerCase();
  const brand = (c.brandDisplayName || '').toLowerCase();
  const searchLower = search.toLowerCase();

  const matchesSearch =
    !search ||
    title.includes(searchLower) ||
    code.includes(searchLower) ||
    brand.includes(searchLower);

  const matchesStatus = statusFilter === 'All' || c.status === statusFilter;

  return matchesSearch && matchesStatus;
});


  console.log(campaignsList)
  if (isFormPage) {
    return <Outlet />;
  }

  const ActionButton = ({ campaign, className = '' }) => {

    console.log(campaign)
  const isActive = campaign.status === 'ACTIVE';
  return (
    <button
      disabled={actionLoadingId === campaign.id}
      onClick={() => handleCampaignAction(campaign)}
      className={`font-medium disabled:opacity-50 ${
        isActive ? 'text-orange-600 hover:text-orange-800' : 'text-red-600 hover:text-red-800'
      } ${className}`}
    >
      {actionLoadingId === campaign.id ? '...' : isActive ? 'Cancel' : 'Delete'}
    </button>
  );
};


if(isLoading) return "Connecting to USPS..."

  return (
    <div className="max-w-full mx-auto p-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Campaign Dashboard</h1>
          <p className="text-sm text-gray-500 mt-1">
            Manage your USPS Informed Delivery campaigns
          </p>
        </div>
        <button className="px-5 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition"
        onClick={() => navigate('/informed/new')}
        >
          + New Campaign
        </button>
      </div>

      {/* Filters */}
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <input
          type="text"
          placeholder="Search by title, code, or brand..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />

      <select
  value={statusFilter}
  onChange={(e) => setStatusFilter(e.target.value)}
  className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
>
  <option value="All">All Statuses</option>
  {availableStatuses.map((status) => (
    <option key={status} value={status}>
      {status}
    </option>
  ))}
</select>
      </div>

      {/* Stats summary */}
      {/* Stats summary */}
<div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">

 

  {/* Active */}
  <div className="bg-white border rounded-xl p-4 shadow-sm">
    <p className="text-sm text-gray-500">Active</p>
    <p className="text-2xl font-bold text-green-600">
      {statusCounts.ACTIVE || 0}
    </p>
  </div>

  {/* Submitted */}
  <div className="bg-white border rounded-xl p-4 shadow-sm">
    <p className="text-sm text-gray-500">Submitted</p>
    <p className="text-2xl font-bold text-blue-600">
      {statusCounts.SUBMITTED || 0}
    </p>
  </div>

  {/* Completed */}
  <div className="bg-white border rounded-xl p-4 shadow-sm">
    <p className="text-sm text-gray-500">Complete</p>
    <p className="text-2xl font-bold text-gray-600">
      {statusCounts.COMPLETE || 0}
    </p>
  </div>
 {/* Total */}
  <div className="bg-white border rounded-xl p-4 shadow-sm">
    <p className="text-sm text-gray-500">Total Campaigns</p>
    <p className="text-2xl font-bold text-gray-800">
      {statusCounts.total}
    </p>
  </div>
  
 <div className="bg-white border rounded-xl p-4 shadow-sm">
    <p className="text-sm text-gray-500">Cancelled / Deleted</p>
    <p className="text-2xl font-bold text-gray-600">
        {(statusCounts.DELETED || 0) + (statusCounts.CANCELLED || 0)}
    </p>
  </div>

</div>
      {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      
        <div className="bg-white border rounded-xl p-4 shadow-sm">
          <p className="text-sm text-gray-500">Total</p>
          <p className="text-2xl font-bold text-gray-800">{campaigns?.length}</p>
        </div>
        <div className="bg-white border rounded-xl p-4 shadow-sm">
          <p className="text-sm text-gray-500">Active</p>
          <p className="text-2xl font-bold text-green-600">
            {campaigns?.filter((c) => c.status === 'Active').length}
          </p>
        </div>
        <div className="bg-white border rounded-xl p-4 shadow-sm">
          <p className="text-sm text-gray-500">Draft</p>
          <p className="text-2xl font-bold text-yellow-600">
            {campaigns?.filter((c) => c.status === 'Draft').length}
          </p>
        </div>
        <div className="bg-white border rounded-xl p-4 shadow-sm">
          <p className="text-sm text-gray-500">Delivered</p>
          <p className="text-2xl font-bold text-gray-600">
            {campaigns?.filter((c) => c.status === 'Completed').length}
          </p>
        </div>
      </div> */}

      {/* Campaign list */}
      {filteredCampaigns?.length === 0 ? (
        <div className="text-center py-16 bg-white border rounded-xl">
          <p className="text-gray-500">No campaigns found.</p>
        </div>
      ) : (
        <div className="bg-white border rounded-xl overflow-hidden shadow-sm">
          {/* Desktop table */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Campaign
                  </th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Code
                  </th>
                   <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Type
                  </th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Dates
                  </th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Shape
                  </th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredCampaigns?.map((campaign) => (
                  <tr key={campaign.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div className="font-medium text-gray-900">
                        {campaign.campaignTitle}
                      </div>
                      <div className="text-sm text-gray-500">
                        {campaign.brandDisplayName}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {campaign.campaignCode}
                    </td>
                       <td className="px-6 py-4 text-sm text-gray-600">
                      {campaign.campaignType}
                    </td>
                 <td className="px-6 py-4 text-sm text-gray-600">
  {formatDate(campaign.startDate)} → {formatDate(campaign.endDate)}
</td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {campaign.mailpieceShape}
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-flex px-4 py-2 rounded-full text-xs font-medium ${
                          statusColors[campaign.status] || 'bg-gray-100 text-gray-700'
                        }`}
                      >
                        {campaign.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm">
                     {
                      (campaign.status === "ACTIVE"  || campaign.status === "SUBMITTED") &&<><button className="text-gray-600 hover:text-gray-900 font-medium" onClick={() => navigate(`/informed/${campaign.id}/edit`)}>
                        Edit
                      </button>< br />
                        <ActionButton campaign={campaign} /></>
                     } 
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile cards */}
          <div className="md:hidden divide-y divide-gray-100">
            {filteredCampaigns?.map((campaign) => (
              <div key={campaign.id} className="p-4">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h3 className="font-medium text-gray-900">
                      {campaign.campaignTitle}
                    </h3>
                    <p className="text-sm text-gray-500">{campaign.brandDisplayName}</p>
                  </div>
                  <span
                    className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      statusColors[campaign.status] || 'bg-gray-100 text-gray-700'
                    }`}
                  >
                    {campaign.status}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-1">
                  Code: {campaign.campaignCode}
                </p>
                <p className="text-sm text-gray-600 mb-1">
                  {campaign.campaignType} 
                </p>
             <p className="text-sm text-gray-600 mb-1">
  {formatDate(campaign.startDate)} → {formatDate(campaign.endDate)}
</p>
                <div className="flex gap-3">
                   <button className="text-gray-600 hover:text-gray-900 font-medium" onClick={() => navigate(`/informed/${campaign.id}/edit`)}>
                        Edit
                      </button>
                        <ActionButton campaign={campaign} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <Outlet />
    </div>
  );
};

export default CampaignDashboard;